import type { ColumnSort } from '@tanstack/react-table';

/** Default inventory table sort; must match API sort on first load. */
export const INVENTORY_DEFAULT_SORT: ColumnSort[] = [{ id: 'domain', desc: false }];
